import { render } from "./NewspaperItem.vue?vue&type=template&id=1691cc8a&scoped=true"
import script from "./NewspaperItem.vue?vue&type=script&lang=js"
export * from "./NewspaperItem.vue?vue&type=script&lang=js"

import "./NewspaperItem.vue?vue&type=style&index=0&id=1691cc8a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1691cc8a"

export default script